import {Mapper} from '@s-ui/domain'

export class FromSearchJSONToUrlVOProxyMapper extends Mapper {
  constructor({
    config,
    fromSearchJSONToUrlVOMapper,
    fromVehicleSearchJSONtoUrlVOMapper,
    fromDealersListJSONtoUrlVOMapper,
    invalidContextSearchError
  }) {
    super({
      config,
      fromSearchJSONToUrlVOMapper,
      fromVehicleSearchJSONtoUrlVOMapper,
      fromDealersListJSONtoUrlVOMapper,
      invalidContextSearchError
    })

    this._config = config
    this._userSavedSearchesPageName = this._config.get('page').USER_SAVED_SEARCHES_PAGE_NAME
    this._adsListPageNames = this._config.get('page').ADS_LIST_PAGE_NAMES
    this._adsListBusinessSubscriptionPageName = this._config.get('page').ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME
    this._adsListSubscriptionPageName = this._config.get('page').ADS_LIST_SUBSCRIPTION_PAGE_NAME
    this._makesDistributorPageName = this._config.get('page').MAKES_DISTRIBUTOR_PAGE_NAME
    this._dealersListPageName = this._config.get('page').DEALERS_LIST_PAGE_NAME
    this._professionalStockPageName = this._config.get('page').PROFESSIONAL_STOCK_PAGE_NAME
    this._professionalStockRentingPageName = this._config.get('page').PROFESSIONAL_STOCK_RENTING_PAGE_NAME
    this._technicalDetailsSearchPageName = this._config.get('page').TECHNICAL_DETAILS_SEARCH_PAGE_NAME
    this._technicalDetailsSearchResultsPageName = this._config.get('page').TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME
    this._homeResultsPageName = this._config.get('page').HOME_PAGE_NAME
    this._fromSearchJSONToUrlVOMapper = fromSearchJSONToUrlVOMapper
    this._fromVehicleSearchJSONtoUrlVOMapper = fromVehicleSearchJSONtoUrlVOMapper
    this._fromDealersListJSONtoUrlVOMapper = fromDealersListJSONtoUrlVOMapper
    this._invalidContextSearchError = invalidContextSearchError
  }

  _getAdsListPageName = ({pageName}) => {
    const isPageFromAdsListPage = this._adsListPageNames.includes(pageName)
    if (isPageFromAdsListPage) return pageName
  }

  createFor = ({pageName}) => {
    switch (pageName) {
      case this._userSavedSearchesPageName:
      case this._professionalStockPageName:
      case this._getAdsListPageName({pageName}):
      case this._adsListSubscriptionPageName:
      case this._adsListBusinessSubscriptionPageName:
      case this._makesDistributorPageName:
      case this._homeResultsPageName:
      case this._professionalStockRentingPageName:
        return this._fromSearchJSONToUrlVOMapper
      case this._dealersListPageName:
        return this._fromDealersListJSONtoUrlVOMapper
      case this._technicalDetailsSearchPageName:
      case this._technicalDetailsSearchResultsPageName:
        return this._fromVehicleSearchJSONtoUrlVOMapper
      default:
        throw this._invalidContextSearchError('Invalid pageName')
    }
  }
}
